import type { ApiCourseWithGroup } from '../types/eventTypes'

const tomorrow = new Date()
tomorrow.setDate(tomorrow.getDate() + 1)

const yesterday = new Date()
yesterday.setDate(yesterday.getDate() - 1)

const newDatePlusHours = (date: Date, h: number) => {
  return new Date(new Date(date).setHours(date.getHours() + h))
}

const attendingLists = [
  {
    courseId: 38,
    id: 2,
    data: [],
  },
  {
    courseId: 101,
    id: 1,
    data: [
      {
        user_id: 28894,
      },
    ],
  },
  {
    courseId: 13,
    id: 3,
    data: [
      {
        user_id: 28894,
      },
    ],
  },
]

const comingCourses: ApiCourseWithGroup[] = [
  {
    data: {
      id: '38',
      attributes: {
        location: 'dsd',
        room: 'd',
        instructor: 'Gard Sandholt',
        start_datetime: tomorrow.toISOString(),
        end_datetime: newDatePlusHours(tomorrow, 2).toISOString(),
        attendees_count_max: 4,
      },
      relationships: {
        attendees: {
          data: attendingLists[1].data,
        },
        group: { data: { id: attendingLists[0].id.toString() } },
      },
    },
  },
  {
    data: {
      id: '101',
      attributes: {
        location: 'dsd',
        room: 'd',
        instructor: 'Gard Sandholt',
        start_datetime: tomorrow.toISOString(),
        end_datetime: newDatePlusHours(tomorrow, 2).toISOString(),
        attendees_count_max: 1,
      },
      relationships: {
        attendees: {
          data: attendingLists[0].data,
        },
        group: { data: { id: attendingLists[1].id.toString() } },
      },
    },
  },
]
const expiredCourses: ApiCourseWithGroup[] = [
  {
    data: {
      id: '13',
      attributes: {
        location: 'Address for earlier date',
        room: 'Room',
        instructor: 'Attensi admin null',
        start_datetime: yesterday.toISOString(),
        end_datetime: newDatePlusHours(yesterday, 2).toISOString(),
        attendees_count_max: 100,
        state: 'expired',
      },
      relationships: {
        attendees: {
          data: attendingLists[1].data,
        },
        group: { data: { id: attendingLists[1].id.toString() } },
      },
    },
  },
]

export const mockCourses = [...comingCourses, ...expiredCourses]

export const eventMock = {
  pagination: {
    current: 1,
    previous: null,
    next: null,
    per_page: 25,
    pages: 1,
    count: 14,
  },
  data: {
    id: '3996',
    attributes: {
      play_count: 3,
      certified: false,
      stars: 1,
      achievable_stars: 1,
      experience: 0,
      high_score: 100,
      percentage: 100,
    },
  },
  included: mockCourses.map((course) => {
    return {
      id: course.data?.id,
      attributes: course.data?.attributes,
      relationships: course.data?.relationships,
      // relationships: {
      //   group: {
      //     data: {
      //       id: course.data?.id,
      //       relationships: course.data?.relationships,
      //     },
      //   },
      // },
    }
  }),
}
